<style lang="less" scoped>
.subbtn{
    margin-left: 50px!important;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
          <div class="title">剂量率和雨量综合统计</div>
          <div class="content">
            <el-form
              label-width="150px"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm"
            >
              <el-row :gutter="10">
                
                <div class="searchs">
                    <el-col :span="20">
                        
                        <el-form-item
                            label="剂量率自动站"
                            prop="stationDoseRate"
                            v-if="doseRateStation.length > 0"
                            >
                            <el-select
                            v-model="ruleForm.stationDoseRate"
                            clearable
                            placeholder="请选择"
                            >
                            <el-option
                                v-for="(item, index) in doseRateStation"
                                :key="index"
                                :label="item.station_name"
                                :value="item.id"
                            ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="雨量自动站"
                            prop="stationRainfall"
                            v-if="rainfallStation.length > 0"
                            >
                            <el-select
                            v-model="ruleForm.stationRainfall"
                            clearable
                            placeholder="请选择"
                            >
                            <el-option
                                v-for="(item, index) in rainfallStation"
                                :key="index"
                                :label="item.station_name"
                                :value="item.id"
                            ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="20">
                        <el-form-item label="时间" prop="startTime">
                            <el-date-picker
                            v-model="ruleForm.startTime"
                            type="datetime"
                            :default-time="'00:00:00'"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="开始时间"
                            clearable
                            ></el-date-picker>
                        </el-form-item>
                        <div class="interval">-</div>
                        <el-form-item label label-width="0" prop="endTime">
                            <el-date-picker
                                v-model="ruleForm.endTime"
                                type="datetime"
                                :default-time="'23:59:59'"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="结束时间"
                                clearable
                            ></el-date-picker>
                        </el-form-item>
                        <el-button
                            class="subbtn"
                            @click="search(ruleForm.startTime,ruleForm.endTime)"
                            type="primary"
                            :loading="submitBtn.isBtnLoading"
                            :disabled="submitBtn.isDisabled"
                            >{{ submitBtn.btnText }}</el-button
                        >
                    </el-col>
                  
                  
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-main-bottom">
            <!-- v-on:downCsvBtn="downCsvBtn" -->

        <div class="content-list">
          <statistics-comprehensive
            :echart-id="'echart1'"
            :option-data="optionData"
            v-on:searchZoom="search"
            :startTime="ruleForm.startTime"
            :endTime="ruleForm.endTime"
            :pageLoading="pageLoading"
            :isShowTitle="true"
            :isZoomFun="true"
          ></statistics-comprehensive>
        </div>
        <a id="csv"></a>
      </div>
    </div>
  </div>
</template>

<script>
import statisticsComprehensive from "@/components/statisticsComprehensive"; //echarts渐变折线

export default {
  name: "dataAcquisition", //高压电离室数据分析-数据获取率
  components: {
    statisticsComprehensive: statisticsComprehensive
  },
  data() {
    return {
      pageLoading: false, //页面loading
      ruleForm: {
        startTime: "",
        endTime: "",
        stationRainfall: "",
        stationDoseRate:""
      },
      rules: {
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" }
        ],
        stationRainfall: [
          { required: true, message: "请选择雨量自动站", trigger: "change" }
        ],
        stationDoseRate: [
          { required: true, message: "请选择剂量率自动站", trigger: "change" }
        ],
        // rainfall: [
        //     { required: true, message: "请选择自动站", trigger: "change" }
        // ]
      },
      submitBtn: {
        btnText: "查询数据",
        isLoading: false,
        isDisabled: false
      },
      optionData: {
        // title: "获取率",
        // unit: "nGy/h",
        // deviceId: "",
        // time: [],
        // data: [],
        title: "",
        // attribute: '',
        unit: "",
        time: new Date().getTime(),
        dataX: [],
        dataY: [],
        dataX1: [],
        dataY1: [],
        zoomX: [],
      },
      deviceTitle: "", //设备名称
      station: [], //自动站
      doseRateStation: [], //剂量率自动站
      rainfallStation: [], //雨量自动站
      chartType:'raingauge'
    //   rainfall:'',//雨量
    //   doseRate:''//剂量率
    };
  },
  computed: {
    doseRateId: function() {
      return this.$route.params.doseRateId || ""; //剂量率设备id
    },
    rainfallId: function() {
      return this.$route.params.rainfallId || ""; //雨量设备id
    },
    rainfall: function() {
      return this.$route.params.rainfall || ""; //雨量type
    },
    doseRate: function() {
      return this.$route.params.doseRate || ""; //剂量率type
    },
    name1: function () {
      return 'doserate'; //高压电离室
    },
    name2: function () {
      return 'raingauge'; //气象
    },
  },
  methods: {
    // search() {
    //   this.$refs["ruleForm"].validate(valid => {
    //     if (valid) {
    //         let startDate = new Date(this.ruleForm.startTime);
    //         let endDate = new Date(this.ruleForm.endTime);
    //         if (startDate > endDate) {
    //         this.$message.error("开始时间不能大于结束时间");
    //         return false;
    //         }
    //         this.searchDoseRate().then(()=>{

    //         })
    //     }
    //   });
    // },
    search(startTime, endTime, isZoom) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // console.log("时间", startTime, endTime);
          let startDate = new Date(startTime);
          let endDate = new Date(endTime);
          let isBar = false; //是否展示bar图
          if (startDate > endDate) {
            this.$message.error("开始时间不能大于结束时间");
          } else {
            let hours = this.pbFunc.getDateDiff(startTime, endTime, "hour");
            console.log("hours", hours,this.name);
            let times = "1h";
            if (hours <= 1) {
              times = "1m";
            } else if (hours <= 24) {
              times = "5m";
            } else if (hours <= 168) {
              times = "1h";
            } else {
              times = "1d";
            }
            if (this.type == "AirosolData" && this.name == "flow") {
              times = "1d";
              isBar = true;
            }
            this.pageLoading = true;
            this.pbFunc
              .echartsData(
                this.ruleForm.stationDoseRate,
                this.doseRate,
                startTime,
                endTime,
                this.name1,
                times,
                "",
                isBar
              )
              .then((res) => {
                this.pageLoading = false;
                if (res) {
                  // console.log("res", res);
                  this.optionData.dataX = [];
                  this.optionData.dataY = [];
               
                    for (let i in res) {
                        this.optionData.dataX.push(res[i].data_time);
                        this.optionData.dataY.push(res[i][this.name1]);
                    }
                    console.log('optionData',this.optionData)
                  if (!isZoom) {
                    this.optionData.zoomX = this.optionData.dataX;
                  }
                }
              });
              this.pbFunc
              .echartsData(
                this.ruleForm.stationRainfall,
                this.rainfall,
                startTime,
                endTime,
                this.name2,
                times,
                "",
                isBar
              )
              .then((res) => {
                this.pageLoading = false;
                if (res) {
                  // console.log("res", res);
                  this.optionData.dataX1 = [];
                  this.optionData.dataY1 = [];
               
                    for (let i in res) {
                        this.optionData.dataX1.push(res[i].data_time);
                        this.optionData.dataY1.push(res[i][this.name2]);
                    }
                    console.log('optionData',this.optionData)
                  if (!isZoom) {
                    this.optionData.zoomX = this.optionData.dataX1;
                  }
                }
              });
          }
        }
      });
    },
    searchDoseRate(){
        return new Promise((resolve, reject) => {
            this.$$http("echartsAchieve", {
                device: this.ruleForm.station,
                device_data_model: this.doseRate,
                start_time: this.ruleForm.startTime,
                end_time: this.ruleForm.endTime
            }).then(results => {
                if (results.data && results.status == 200) {
                    let datas = results.data;
                    this.optionData.data = [];
                    for (let i in datas) {
                    this.optionData.data.push([
                        datas[i].date,
                        datas[i].receive_rate
                    ]);
                    }
                    this.optionData.time = [
                    this.optionData.data[0][0],
                    this.optionData.data[this.optionData.data.length - 1][0]
                    ];
                    this.optionData.deviceId = this.ruleForm.station;
                    console.log("datas", this.optionData);
                } else {
                    this.$message.error(
                    results.data.msg ? results.data.msg : "查询失败"
                    );
                }
                })
                .catch(err => {});
        });
    },
    //下载获取率数据
    // downCsvBtn() {
    //   if (this.ruleForm.startTime && this.ruleForm.endTime) {
    //     // this.optionData.time = this.ruleForm.time;
    //     this.$$http("echartsAchieveDownCsv", {
    //       device: this.ruleForm.station,
    //       device_data_model: this.type,
    //       start_time: this.ruleForm.startTime,
    //       end_time: this.ruleForm.endTime
    //     })
    //       .then(results => {
    //         if (results.data && results.status == 200) {
    //           let csv = this.optionData.title + ".csv";
    //           let anchor = document.getElementById("csv");
    //           anchor.href =
    //             "data:text/csv;charset=utf-8," +
    //             encodeURIComponent(results.data);
    //           anchor.target = "_blank";
    //           anchor.download = csv;
    //           anchor.click();
    //           this.$message.success("下载成功");
    //         } else {
    //           this.$message.error(
    //             results.data.msg ? results.data.msg : "下载失败"
    //           );
    //         }
    //       })
    //       .catch(err => {});
    //   } else {
    //     this.$message.error("请选择时间");
    //   }
    // },
    // //补传数据成功后，更新数据列表
    // achieveDataUpdate(isUpdate) {
    //   if (isUpdate) this.search();
    // },
    //获取自动站
    getStationList(id,type) {
      this.pbFunc.stationList(id).then(res => {
        // console.log("自动站列表", res);
        if(type=='doserate'){
            this.doseRateStation = res.other_station_devices;

        }else if(type=='raingauge'){
            this.rainfallStation = res.other_station_devices;
        }
        // if (this.station.length == 1) {
        //   console.log("999");
          
        //   this.ruleForm.station = this.station[0].id;
        // }
      });
    }
  },
  created() {
    this.getStationList(this.doseRateId,this.name1);
    this.getStationList(this.rainfallId,this.name2);
    // this.deviceTitle = this.pbFunc.deviceName(this.id, this.type);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dataStatistics/comprehensive.vue